import { MenuItem, Select, TextField } from "@mui/material";
import { forwardRef, useEffect } from "react";
import PhoneInput, {
  getCountries,
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input/input";
import { CountryCode } from "libphonenumber-js/types";
import en from "react-phone-number-input/locale/en.json";

interface CountrySelectProps {
  country: any;
  setCountry: any;
}

interface PhoneEntryProps {
  country: any;
  setCountry: any;
  phoneNumber: any;
  setPhoneNumber: any;
  phoneInputComponent: any;
  setDisableButton?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ContactPhoneInput = forwardRef((props, ref) => {
  return (
    <TextField
      {...props}
      label="Contact Phone Number"
      key="contactPhoneInputField"
      variant="standard"
      inputRef={ref}
      required
    />
  );
});

export const ActivityPhoneInput = forwardRef((props, ref) => {
  return (
    <TextField
      {...props}
      label="Activity Phone Number"
      key="activityPhoneInputField"
      variant="standard"
      inputRef={ref}
      required
    />
  );
});

const CountrySelect: React.FC<CountrySelectProps> = ({
  country,
  setCountry,
}) => {
  return (
    <Select
      value={country}
      onChange={(event) => setCountry(event.target.value as CountryCode)}
    >
      {getCountries().map((countryCode: CountryCode) => (
        <MenuItem key={countryCode} value={countryCode}>
          {en[countryCode]}
        </MenuItem>
      ))}
    </Select>
  );
};

export const PhoneEntry: React.FC<PhoneEntryProps> = ({
  country,
  setCountry,
  phoneNumber,
  setPhoneNumber,
  phoneInputComponent,
  setDisableButton,
}) => {
  const countryCode = parsePhoneNumber(phoneNumber ?? "")?.country;
  const errorText = phoneNumber
    ? isValidPhoneNumber(phoneNumber, countryCode)
      ? null
      : "Invalid phone number for country"
    : null;

  useEffect(() => {
    errorText ? setDisableButton?.(true) : setDisableButton?.(false);
  }, [errorText]);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
      <CountrySelect country={country} setCountry={setCountry} />
      <PhoneInput
        defaultCountry="US"
        country={country}
        rules={{
          required: true,
        }}
        value={phoneNumber}
        onChange={setPhoneNumber as any}
        inputComponent={phoneInputComponent}
        error={errorText}
        helperText={errorText}
      />
    </div>
  );
};
